import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, Spin } from 'antd'
import MyIcon from '../../../components/general/icon'
import AddExerciseRecipe from './add'
import EditExerciseRecipe from './edit'
import DeleteExerciseRecipe from './delete'
import IngredientNutrition from './ingredientNutrition/index'

const ExerciseRecipe = (props) => {
  const [isLoading, setIsLoading] = useState(true)
  const [propsData, setPropsData] = useState({})
  const [exerciseRecipeData, setExerciseRecipeData] = useState([])
  const [isAddExerciseRecipeVisible, setIsAddExerciseRecipeVisible] = useState(false)
  const [isEditExerciseRecipeVisible, setIsEditExerciseRecipeVisible] = useState(false)
  const [isDeleteExerciseRecipeVisible, setIsDeleteExerciseRecipeVisible] = useState(false)
  const [isManageIngredientVisible, setIsManageIngredientVisible] = useState(false)

  const getExerciseRecipeData = () => {
    axios.post('/admin/user/exercise_recipes/get', { 
      user_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setExerciseRecipeData(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getExerciseRecipeData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const addExerciseRecipe = () => {
    setIsAddExerciseRecipeVisible(true)
    setPropsData({ userOid: props.data.oid})
  }

  const editExerciseRecipe = (item) => {
    setIsEditExerciseRecipeVisible(true)
    setPropsData({ item: item})
  }

  const deleteExerciseRecipe = (oid, name) => {
    setIsDeleteExerciseRecipeVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  const manageIngredient = (oid, name) => {
    setIsManageIngredientVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <Modal 
      title="运动食谱"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>

      <Spin spinning={isLoading}>
        <div className='public-filter' style={{marginBottom: '-20px'}}>
          <div className='public-datail-button' onClick={() => { addExerciseRecipe() }}>添加运动食谱</div>
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{width: '400px'}}>
                  <div className='public-main-style2-title'>食谱名称</div>
                </th>
                <th>食材数量</th>
                <th></th>
                <th style={{width: '50px'}}></th>
              </tr>
            </thead>

            <tbody>
              {exerciseRecipeData && (exerciseRecipeData.length > 0 ? (exerciseRecipeData.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editExerciseRecipe(item) }}>
                  <td style={{width: '400px'}}>
                    <div className='public-main-style2-title'>{item.name}</div>
                  </td>
                  <td>{item.ingredient_numbers}</td>
                  <td>
                    <div className='public-main-style2-manage' onClick={(event) => {event.stopPropagation(); manageIngredient(item.oid, item.name)}}>管理食材</div>
                  </td>
                  <td style={{width: '50px'}}>
                    <div className='public-main-style2-operation-box'>
                      <div className='public-main-style2-operation' 
                        onClick={(event) => {event.stopPropagation(); deleteExerciseRecipe(item.oid, item.name)}}>
                        <MyIcon name='huishouzhan' />
                      </div>
                    </div>
                  </td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="3"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Spin>

      {isAddExerciseRecipeVisible && <AddExerciseRecipe
        data={propsData}
        isOpen={isAddExerciseRecipeVisible} 
        isCancel={() => { setIsAddExerciseRecipeVisible(false) }} 
        getExerciseRecipeData={getExerciseRecipeData} 
      />}
      {isEditExerciseRecipeVisible && <EditExerciseRecipe
        data={propsData}
        isOpen={isEditExerciseRecipeVisible} 
        isCancel={() => { setIsEditExerciseRecipeVisible(false) }} 
        getExerciseRecipeData={getExerciseRecipeData} 
      />}
      {isDeleteExerciseRecipeVisible && <DeleteExerciseRecipe
        data={propsData}
        isOpen={isDeleteExerciseRecipeVisible} 
        isCancel={() => { setIsDeleteExerciseRecipeVisible(false) }} 
        getExerciseRecipeData={getExerciseRecipeData} 
      />}
      {isManageIngredientVisible && <IngredientNutrition
        data={propsData}
        isOpen={isManageIngredientVisible} 
        isCancel={() => { setIsManageIngredientVisible(false) }} 
        getExerciseRecipeData={getExerciseRecipeData} 
      />}
    </Modal>
  )
}

export default ExerciseRecipe
